import { CiaSubLayers, SubLayerTypes } from '@constants/canvas/layers';
import {
  FilterableNodeDto,
  ModelFilters,
} from '@context/ProjectFilters/matchesModelFilters';

const NO_CIA_SELECTION: ModelFilters['ciaFilters'] = {
  assurance_level: {},
  coverage: {},
  applicability: {},
};

/**
 * The selection the shared predicate judges one entity against while a
 * questionnaire result (View Controls) is active.
 *
 * That view mirrors the report, which applies the CIA answers to the control
 * layers alone and excludes only "In development" controls. Two categories
 * are therefore neutralised per entity, outside the predicate so that its
 * other consumers never inherit the view: the CIA categories for an entity
 * outside the CIA sub-layers, and Operational status for an entity that
 * carries none. Every other category still applies, which is what keeps the
 * view from resurrecting what Scope, review, validation, operating model or
 * partners hid. Without a result the selection comes back as it was, by
 * identity.
 */
export const questionnaireViewFilters = (
  filters: ModelFilters,
  dto: FilterableNodeDto | undefined,
  subLayer: SubLayerTypes | undefined,
  hasResult: boolean,
): ModelFilters => {
  if (!hasResult) return filters;

  const isUnstatused = !dto?.meta_data?.operational_status;

  const isOutsideCiaLayers =
    !subLayer || !(CiaSubLayers as SubLayerTypes[]).includes(subLayer);

  if (!isUnstatused && !isOutsideCiaLayers) return filters;

  return {
    ...filters,
    ...(isUnstatused ? { operationalStatuses: [] } : {}),
    ...(isOutsideCiaLayers ? { ciaFilters: NO_CIA_SELECTION } : {}),
  };
};
